<div class="grid">
	<!-- FILTERS -->
	<div class="col-12" [class]="this.underTablet() ? 'flex justify-content-center' : ''">
		<form [formGroup]="deviceFilters">
			<div class="grid mt-0">
				<div class="col-12 pt-0">
					<div class="flex align-items-center justify-content-center gap-2">
						<p-button label="{{ 'SAVE' | translate }}" icon="pi cm-check" (click)="saveSharingSystem()"
							[rounded]="false" [text]="true" severity="success" styleClass="font-bold border-green-700">
						</p-button>
						<p-button label="{{ 'CANCEL' | translate }}" icon="pi cm-cancel"
							(click)="disableMaximumSharingSystem()" [rounded]="false" [text]="true" severity="danger"
							styleClass="font-bold border-red-600">
						</p-button>
					</div>
				</div>
				<div class="col-12 pt-0">
					<div [class]="onExtendedMobile() ? 'grid' : 'flex align-items-center justify-content-center gap-2'">
						<div [class]="onExtendedMobile() ? 'col-12' : ''">
							<p-button label="{{ 'EXPORT_PLANT_SHARING' | translate }}" icon="pi cm-cloud-arrow-up"
								(click)="exportSharingSystem()" [rounded]="false" [text]="true" severity="secondary"
								styleClass="font-bold border-0">
							</p-button>
						</div>
						<div [class]="onExtendedMobile() ? 'col-12 pt-0' : ''">
							<p-button label="{{ 'IMPORT_PLANT_SHARING' | translate }}" icon="pi cm-cloud-arrow-down"
								(click)="importSharingSystem()" [rounded]="false" [text]="true" severity="secondary"
								styleClass="font-bold border-0">
							</p-button>
						</div>
					</div>
				</div>
				<div class="col-12" [class]="onExtendedMobile() ? 'py-0' : ''">
					<div
						[class]="(this.screenWidth <= COLUMN_TITLE_MIN_WD) ? 'grid' : 'flex align-items-center justify-content-around w-full'">
						<div
							[class]="(this.screenWidth <= COLUMN_TITLE_MIN_WD) ? 'col-6 flex align-items-center justify-content-center' : 'flex align-items-center'">
							<p-checkbox formControlName="assignFilter" name="activeFilter" [binary]="true"
								styleClass="mx-2"></p-checkbox>
							<p-tag icon="pi cm-user" value="{{ 'VCT_SHARE_ASSIGN' | translate }}" severity="success"></p-tag>
						</div>
						<div
							[class]="(this.screenWidth <= COLUMN_TITLE_MIN_WD) ? 'col-6 flex align-items-center justify-content-center' : 'flex align-items-center'">
							<p-checkbox formControlName="pendingFilter" name="readyFilter" [binary]="true"
								styleClass="mx-2"></p-checkbox>
							<p-tag icon="pi cm-mail" value="{{ 'INVITED_PENDING' | translate }}" severity="warning"></p-tag>
						</div>
						<div
							[class]="(this.screenWidth <= COLUMN_TITLE_MIN_WD) ? 'col-6 flex align-items-center justify-content-center' : 'flex align-items-center'">
							<p-checkbox formControlName="notAssignFilter" name="expiredFilter" [binary]="true"
								styleClass="mx-2"></p-checkbox>
							<p-tag icon="pi cm-cancel" value="{{ 'VCT_SHARE_NOT_ASSIGN' | translate }}" severity="danger"></p-tag>
						</div>
					</div>
				</div>
				<div class="col-12">
					<div class="grid">
						<div [class]="onExtendedMobile() ? 'col-12' : 'col-6'">
							<div class="flex align-items-center justify-content-center gap-1">
								<p-checkbox formControlName="onlyUnit" name="onlyUnit" [binary]="true" styleClass="mx-2"></p-checkbox>
								<div>{{ 'VIEW_ONLY' | translate }}</div>
								<p-tag icon="pi cm-derivate" value="{{ 'UNIT' | translate }}"
									styleClass="text-0 p-tag-lightBlue0240"></p-tag>
								<div>{{ 'AND' | translate }}</div>
								<p-tag icon="pi cm-plate" value="{{ 'VCT_OPENS' | translate }}"
									styleClass="text-0 p-tag-lightBlue0240"></p-tag>
							</div>
						</div>
						<div [class]="onExtendedMobile() ? 'col-12 pt-0' : 'col-6'">
							<div class="flex align-items-center justify-content-center gap-1">
								<p-checkbox formControlName="filterWarning" name="filterWarning" [binary]="true" styleClass="mx-2"></p-checkbox>
								<div>{{ 'VIEW_ONLY' | translate }}</div>
								<p-tag icon="pi cm-alert" value="{{ 'VCT_ERROR_WARNING' | translate }} ({{ errorCount }})" severity="warning"></p-tag>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 py-0 flex align-items-center justify-content-center">
					<span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
						<i class="pi cm-search"></i>
						<input formControlName="searchFilter" pInputText type="text" [ngClass]="dynamicInputTextWidth()"
							class="pr-6 surface-900" id="supportrequest-rbelog-input-search"
							placeholder="{{ 'SEARCH' | translate }}" maxlength="254" />
					</span>
				</div>
			</div>
		</form>
	</div>
	<!-- ALERT SUCCESS or ERROR IMPORT -->
	<div class="col-12 pt-0">
		<div *ngIf="importFileSuccess === ImportFileSharingSuccess.NOT_IMPORTED_BLOCK_ERRORS" class="flex align-items-center justify-content-center bg-red-200 p-1 border-round-xl gap-1">
			<i class="pi cm-cancel text-xl text-red-700"></i>
			<p-tag value="{{'VCT_UPLOAD_WRITE_DATA_FAILED' | translate}}" severity="danger"></p-tag>
		</div>
		<div *ngIf="importFileSuccess === ImportFileSharingSuccess.IMPORTED_SUCCESS && errorCount > 0" class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl gap-1">
			<i class="pi cm-alert text-xl text-yellow-700"></i>
			<p-tag value="{{'VCT_UPLOAD_WRITE_DATA_DONE_WITH_WARNING' | translate}}" severity="warning"></p-tag>
		</div>
		<div *ngIf="importFileSuccess === ImportFileSharingSuccess.IMPORTED_SUCCESS && errorCount === 0" class="flex align-items-center justify-content-center bg-green-200 p-1 border-round-xl gap-1">
			<i class="pi cm-check text-xl text-green-700"></i>
			<p-tag value="{{'VCT_UPLOAD_WRITE_DATA_DONE' | translate}}" severity="success"></p-tag>
		</div>
	</div>
</div>